<template>
  <div class="app">
    <div id="outline">

    </div>
  </div>
</template>

<script>
  //引入安装的axios插件
  import axios from 'axios'
  import Cookies from 'js-cookie'
  export default {
    data() {
      return {
        ssoApi: 'http://5g.hxpwr.com:7133/api',
      }
    },

    computed: {

    },

    mounted() {
      let _this = this;
      let token;
			let form = this.$route.query.form;
			let url;
			if (form == 'SsoA') {
				url = 'http://api.home.hxpwr.com/api/User/UserLoginFromToken';
        token = this.$route.query.ssk;
			} else {
				url = 'http://5g.hxpwr.com:7133/api/Sso/LoginSso?systemName=2';
        token = this.$route.query.ssk.slice(2);
			}
      axios({
        method: 'get',
				url: url,
        // url: 'http://5g.hxpwr.com:7133/api/Sso/LoginSso?systemName=2',
        headers: {
          'content-Type': 'application/json;charset=UTF-8',
          "Authorization": `bearer ${token}`
        }
      }).then(res => {
        let data;
        if (form == 'SsoA') {
          data = res.data;
        } else {
          data = JSON.parse(res.data);
        }

        if (data.Success) {

          // 储存后台返回位置
          Cookies.set('cityName', data.Data.AddressName);

          // 保存token
          Cookies.set('Token', data.Data.token_type + ' ' + data.Data.access_token);

          // 保存集团部门编号
          Cookies.set('AdminData', {
            GroupCode: data.Data.GroupCode,
            CompanyCode: data.Data.CompanyCode,
            DepartmentCode: data.Data.DepartmentCode,
            IsAdmin: data.Data.IsAdmin,
            TittleName: data.Data.TittleName,
            TittleNameEN: data.Data.TittleNameEN,
            ImageUrl: data.Data.ImageUrl
          });

          // 保存登录名
          Cookies.set('UserLogin', data.Data.UserInfo.UserLogin);

          _this.$store.dispatch("setCodeValue",
            `${data.Data.GroupCode}${data.Data.CompanyCode}${data.Data.DepartmentCode}`);

          _this.$router.push({
            name: 'home'
          })
        } else {
          _this.$Message['error']({
            background: true,
            content: data.Message
          });
        }
      }).catch(err => {
        console.log(err);
      })
    },

    methods: {

    }
  }
</script>

<style scoped="scoped">
  #outline {
    width: 100%;
    min-width: 60vw;
    margin: 0 auto;
    height: 100vh;
    background-image: url(../../assets/newHome/background.png);
    background-size: 100% 100%;
    background-position: 50%;
    z-index: -2;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/intermediate/intermediate.vue